import dayjs from "dayjs";
import styled from "styled-components";

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--brand-blue-25);
  border: 1px solid var(--brand-purple-500);
  color: var(--brand-purple-700);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  vertical-align: middle;
`;

interface ICertifiedChipProps {
  /** ISO time the user was certified; nothing renders without it. */
  certifiedAt?: string | null;
}

/** "Certified Oct 21, 2026" — the hover text, in the viewer's local time. */
export function formatCertifiedDate(certifiedAt: string): string {
  return dayjs(certifiedAt).format("MMM D, YYYY");
}

/** CLE-3015 — the "Clear Certified" badge, with the certification date on hover. */
export function CertifiedChip({ certifiedAt }: ICertifiedChipProps) {
  if (!certifiedAt || !dayjs(certifiedAt).isValid()) {
    return null;
  }

  const hover = `Certified ${formatCertifiedDate(certifiedAt)}`;

  return (
    <Chip title={hover} aria-label={`Clear Certified, ${hover.toLowerCase()}`}>
      <i className="pi pi-verified" aria-hidden />
      Clear Certified
    </Chip>
  );
}
